module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.integration.integrationStatus == 0 || _vm.integration.integrationStatus == 4) ? _c('div', {
    staticClass: "px-5 pt-4 d-flex flex-column"
  }, [_c('request-activation', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1) : (_vm.integration.integrationStatus == 1) ? _c('div', {
    staticClass: "px-5 pt-4 d-flex flex-column"
  }, [_c('activated', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1) : (_vm.integration.integrationStatus == 2) ? _c('div', {
    staticClass: "px-5 pt-4 d-flex flex-column"
  }, [_c('pending-activation', {
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1) : (_vm.integration.integrationStatus == 3) ? _c('div', {
    staticClass: "px-5 pt-4 d-flex flex-column"
  }, [_c('pending-deactivation', {
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7583d218", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7583d218"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/popupParts/stateLabel.vue
// module id = 3202
// module chunks = 0